import { SimpleGrid } from "@mantine/core";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";

export default function ProductGrid({ products }) {
  if (!products.length) {
    return null;
  }

  return (
    <SimpleGrid
      cols={4}
      spacing={24}
      breakpoints={[
        { maxWidth: "75rem", cols: 2 },
        { maxWidth: "48rem", cols: 1 },
      ]}
    >
      {products.map((product) => (
        <Link
          key={product.url_link}
          to={`/${product.url_link}`}
          style={{ textDecoration: "none", color: "inherit", display: "block", height: "100%" }}
        >
          <ProductCard product={product} />
        </Link>
      ))}
    </SimpleGrid>
  );
}
